import formattingFunctions from '@/components/table/formattingFunctions.js'
import worklistFormat from '@/components/table/worklistFormat.js'
import moment from 'moment'
var dt = require('datatables.net')

;(function(factory) {
  factory(jQuery, moment)
})(function($, moment) {
  $.fn.dataTable.moment = function(format, locale) {
    var types = $.fn.dataTable.ext.type

    // Add type detection
    types.detect.unshift(function(d) {
      if (d) {
        // Strip HTML tags and newline characters if possible
        if (d.replace) {
          d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '')
        }

        // Strip out surrounding white space
        d = $.trim(d)
      }

      // Null and empty values are acceptable
      if (d === '' || d === null) {
        return 'moment-' + format
      }

      return moment(d, format, locale, true).isValid() ? 'moment-' + format : null
    })

    // Add sorting method - use an integer for the sorting
    types.order['moment-' + format + '-pre'] = function(d) {
      if (d) {
        // Strip HTML tags and newline characters if possible
        if (d.replace) {
          d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '')
        }

        // Strip out surrounding white space
        d = $.trim(d)
      }

      return !moment(d, format, locale, true).isValid()
        ? Infinity
        : parseInt(moment(d, format, locale, true).format('x'), 10)
    }
  }
})

$(function() {
  $.fn.dataTable.moment('YYYY-MM-DD HH:mm') // date format

  $('body')
    .on('click', '.table__cell--resend-mail > a', function(e) {
      e.stopPropagation()
    })
    .on('click', '[data-href]', function(e) {
      var url = $(this).data('href')
      if ($(this).attr('data-target') == '_blank') {
        window.open(url, '_blank')
      } else {
        window.location = url
      }
    })
    .on('click', '.table__row--collapsible', function(e) {
      // Prevent table actions from triggering collapsing
      if ($(e.target).parents('.table__actions').length) {
        return
      }

      if ($(e.target).parents('.table--withcollapserows').length) {
        var tr = $(this).closest('tr')
        const dataTable = $('.datatable').DataTable()
        var row = dataTable.row(tr)

        if (row.child.isShown()) {
          row.child.hide()
          tr.removeClass('shown')
        } else {
          row
            .child(
              worklistFormat.childRow(row.data()),
              'table__row table__row--sub table__row--sub--worklist',
            )
            .show()
          tr.addClass('shown')
        }
        tr.toggleClass('table__row--collapsed')
        return
      }

      $(this)
        .toggleClass('table__row--collapsed')
        .nextUntil(':not(.table__row--sub)')
        .toggleClass('table__row--hidden')
    })
    .on('change', '[data-role="expand-all"]', function(evt, ui) {
      var $input = $(evt.target)
      var $allRows = $('.table__row--collapsible')
      if ($input.prop('checked')) {
        $allRows.filter('.table__row--collapsed').click()
      } else {
        $allRows.filter(':not(.table__row--collapsed)').click()
      }
    })

  const $dataTable = $('.datatable')
  $dataTable.each(function(index, elm) {
    var $table = $(elm)

    var options = {
      lengthChange: false,
      info: false,
      pageLength: 25,
      language: {
        paginate: {
          next: '>',
          previous: '<',
        },
      },
      retrieve: true,
      dom: 'lrtip',
      autoWidth: false,
      stateSave: true,
      stateSaveCallback: function(settings, data) {
        window.location.hash = JSON.stringify(data)
      },
      stateLoadCallback: function(settings) {
        try {
          var hash = window.location.hash
          hash = hash.substr(1)
          hash = decodeURI(hash)
          const state = JSON.parse(hash)
          // Make sure the searched string is prefilled into the search field
          if (state.search && state.search.search !== '' && $('input[type=search]')) {
            $('input[type=search]').val(state.search.search)
          }
          return state
        } catch (e) {
          return false
        }
      },
    }

    var columnDefs = []
    $table.find('tr:first th').each(function(index, elm) {
      var $elm = $(elm)
      var columnDef = {}
      if ($elm.data('type')) {
        columnDef.type = $elm.data('type')
      }
      if ($elm.data('hidden')) {
        columnDef.visible = false
        columnDef.targets = [index]
      }
      columnDefs.push(columnDef)
    })

    options.columnDefs = columnDefs

    if ($table.data('ajax-url')) {
      options.ajax = $table.data('ajax-url')
      options.serverSide = true
      if ($table.data('server-side')) {
        options.serverSide = $table.data('server-side')
      }

      options.createdRow = function(tr, data, index, tds) {
        if (data.Key) {
          $(tr).attr('data-id', data.Key)
        }

        if (data.detail_url) {
          $(tr).attr('data-href', data.detail_url)
        }

        if (data.data_url) {
          $(tr).attr('data-url', data.data_url)
          $(tr).attr('data-toggle', 'drawer')
        }

        if (data.context_menu_url) {
          $(tr).attr('data-context-menu', data.context_menu_url)
        }

        if ($table.data('row-class')) {
          $(tr).addClass($table.data('row-class'))
        }
      }

      var columns = []

      $table.find('tr:first th').each(function(index, elm) {
        var $elm = $(elm)
        var column = {}
        column.defaultContent = ''
        // Make sure that data is rendered as text by default (to prevent HTML from being rendered)
        column.render = $.fn.dataTable.render.text()

        if ($elm.data('type')) {
          var type = $elm.data('type')
          if (typeof formattingFunctions[type] != 'undefined') {
            column.render = formattingFunctions[type]
          }
          column.type = type
        }
        if ($elm.data('hidden')) {
          column.visible = false
        }

        if ($elm.data('field')) {
          column.data = $elm.data('field')
        } else {
          column.data = null
        }
        column.className = 'table__cell'
        columns.push(column)
      })

      options.columns = columns
      delete options.columnDefs
    }

    if ($table.data('order-col') != undefined) {
      var col = $table.data('order-col')
      var dir = $table.data('order-dir')
      if (dir == undefined) {
        dir = 'asc'
      }
      options.order = [[col, dir]]
    }

    if (process.env.NODE_ENV === 'development') console.log('options', options)

    var table = $table.DataTable(options)
    var $tableFilters = $('div.table-toolbar__filters form')

    if ($table.data('ajax-url') && $tableFilters.length) {
      table.on('xhr.dt', function(e, settings, json, xhr) {
        $tableFilters
          .find('[data-reset]')
          .text('Reset')
          .prop('disabled', false)
      })

      $tableFilters.on('submit', function(e) {
        // Make sure we always have the URL without query parameters
        const url = $table.data('ajax-url').split('?')[0]
        const serializedForm = $(this).serialize()
        if (history && history.pushState) {
          const historyItem = {
            title: '',
            url: url + '?' + serializedForm + window.location.hash,
          }
          history.pushState(historyItem, historyItem.title, historyItem.url)
        }
        table.ajax.url(url + '?' + serializedForm).load()
        e.preventDefault()
      })
    }
    $table.on('draw.dt', function() {
      $table.removeClass('content-loading')
      $('[data-role="expand-all"]').prop('checked', false)
    })
    $table.on('preXhr.dt', function() {
      $table.addClass('content-loading')
    })
  })
})

//currency sorting
jQuery.extend(jQuery.fn.dataTableExt.oSort, {
  'currency-pre': function(a) {
    a = a === '-' ? 0 : a.replace(/[^\d\-.]/g, '')
    return parseFloat(a)
  },

  'currency-asc': function(a, b) {
    return a - b
  },

  'currency-desc': function(a, b) {
    return b - a
  },
  'datetimesort-asc': function(a, b) {
    if (a.length === 0) {
      return true
    }
    return a - b
  },
})
